import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'empty-state',
  props: {
    icon: {
      default: ''
    },
    text: null,
    buttonText: {
      default: ''
    },
    subText: null
  },
  emits: ['action'],
  setup(__props, {
    emit
  }) {
    return {
      __sfc: true,
      emit
    };
  }
});